import { privateApi } from "../../api";

// Asset Type APIs
const createAssetType = async (name) => {
    return await privateApi.post('inventory/assetType', { name });
};

const getAssetTypes = async () => {
    return await privateApi.get('inventory/assetTypes');
};

// Brand APIs
const createBrand = async (name, assetTypes) => {
    return await privateApi.post('inventory/brand', { name, assetTypes });
};

const getBrands = async (assetType) => {
    const params = assetType ? { assetType } : {};
    return await privateApi.get('inventory/brands', { params });
};

// Model APIs
const createModel = async (name, brand) => {
    return await privateApi.post('inventory/model', { name, brand });
};

const getModels = async (brand) => {
    const params = brand ? { brand } : {};
    return await privateApi.get('inventory/models', { params });
};

// Inventory Item APIs
const createInventoryItem = async (itemData) => {
    return await privateApi.post('inventory', itemData);
};

const getInventoryItems = async (queryParams) => {
    return await privateApi.get('inventory', { params: queryParams });
};

const updateInventoryItem = async (id, itemData) => {
    return await privateApi.put(`inventory/${id}`, itemData);
};

const deleteInventoryItem = async (id) => {
    return await privateApi.delete(`inventory/${id}`);
};

const getInventoryUsageHistory = async (id) => {
    return await privateApi.get(`inventory/usageHistory/${id}`);
};

const getInventoryForExport = async (queryParams) => {
    return await privateApi.get('inventory/export', { params: queryParams });
};

const getUsageHistoryForExport = async (id) => {
    return await privateApi.get(`inventory/usageHistory/export/${id}`);
};

export {
    createAssetType,
    getAssetTypes,
    createBrand,
    getBrands,
    createModel,
    getModels,
    createInventoryItem,
    getInventoryItems,
    updateInventoryItem,
    deleteInventoryItem,
    getInventoryUsageHistory,
    getInventoryForExport,
    getUsageHistoryForExport
};

